import { OptionRadioMark, OverlayTooltip } from 'components/Overlay';
import { useState } from 'react';
import { getColorsStatus } from 'crono-fe-common/utils';
import {
  SingleStatusOptionComponentWrapper,
  StatusTooltipPickerWrapper,
} from './style';
import { colors } from 'crono-fe-common/theme';
import { StatusColors } from 'crono-fe-common/constants/constants';
import { ExternalPropertyShort } from 'crono-fe-common/types/externalProperty';

interface IPropsStatusTooltipPicker {
  statuses: ExternalPropertyShort[];
  onClick?: () => void;

  currentStatus?: string;
  setStatus?: (status: string) => void;
}

const StatusTooltipPicker = ({
  statuses,
  onClick,
  currentStatus,
  setStatus,
}: IPropsStatusTooltipPicker) => {
  const changeStatus = (status: string) => {
    if (setStatus) {
      setStatus(status);
    }
  };
  return (
    <StatusTooltipPickerWrapper>
      <p className="text-xs leading-4 font-medium">Change Status</p>
      <div className="status-list-container">
        {statuses.map((status, index) => {
          const statusColor = getColorsStatus(index, statuses.length);
          const selected = status.option === currentStatus;
          return (
            status && (
              <SingleStatusOptionComponent
                selected={selected}
                statusColor={statusColor}
                status={status}
                changeStatus={changeStatus}
                key={index}
              />
            )
          );
        })}
      </div>
    </StatusTooltipPickerWrapper>
  );
};

interface IProps {
  selected: boolean;
  statusColor: StatusColors;
  status: ExternalPropertyShort;
  changeStatus: (status: string) => void;
  style?: React.CSSProperties;
}

export const SingleStatusOptionComponent = ({
  selected,
  statusColor,
  status,
  changeStatus,
  style = {},
}: IProps) => {
  const [hover, setHover] = useState(false);

  return (
    <SingleStatusOptionComponentWrapper
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        role="radio"
        aria-checked={selected}
        className={
          !selected
            ? 'status-option-picker-not-selected'
            : 'status-option-picker'
        }
        style={{
          background: selected
            ? statusColor.dark
            : hover
              ? statusColor.lightHover
              : statusColor.light,
          color: selected ? colors.white : statusColor.dark,
          ...style,
        }}
        onClick={() => changeStatus(status.option)}
      >
        <OverlayTooltip content={status.label}>
          <p className="truncate text-xs leading-4 font-medium">
            {status.label}
          </p>
        </OverlayTooltip>
        <OptionRadioMark selected={selected} color={statusColor.dark} />
      </div>
    </SingleStatusOptionComponentWrapper>
  );
};

export default StatusTooltipPicker;
